import { render, staticRenderFns } from "./UserNew.vue?vue&type=template&id=324711a2&scoped=true&"
import script from "./UserNew.vue?vue&type=script&lang=js&"
export * from "./UserNew.vue?vue&type=script&lang=js&"
import style0 from "./UserNew.vue?vue&type=style&index=0&id=324711a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324711a2",
  null
  
)

export default component.exports